var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import { getDetailAddress } from "./detail";
import { Input } from "@mui/joy";
import { useTranslation } from "react-i18next";
/** <b>Composant d'affichage en mode édition d'un champ de type addresse</b>*/
export default function AddressFieldEdit(_a) {
    var fieldName = _a.fieldName, fieldMetadata = _a.fieldMetadata, record = _a.record, onUpdate = _a.onUpdate, componentClassName = _a.componentClassName, fieldDef = _a.fieldDef, moduleName = _a.moduleName;
    var group = fieldMetadata.group;
    var field = group + "_" + "state";
    var _b = useTranslation([moduleName || "Contacts"]), t = _b.t, i18n = _b.i18n;
    var _c = useState({
        street: "",
        street_2: "",
        street_3: "",
        street_4: "",
        city: "",
        state: "",
        postalcode: "",
        country: "",
    }), value = _c[0], setValue = _c[1];
    var defaultValue = useMemo(function () {
        if (!record) {
            return;
        }
        return getDetailAddress(group, record, fieldDef);
    }, [fieldName, record]);
    useEffect(function () {
        setValue(defaultValue || {});
    }, [defaultValue]);
    var handleInputChange = function (event) {
        var _a = event.target, name = _a.name, value = _a.value;
        setValue(function (prevState) {
            var _a;
            return (__assign(__assign({}, prevState), (_a = {}, _a[name] = value, _a)));
        });
        var field = group + "_" + name;
        record[field] = value;
        onUpdate && onUpdate(record);
    };
    return (_jsx("div", __assign({ className: " w-full items-center space-y-2 pl-4 pt-2" }, { children: _jsx("div", __assign({ className: " w-full items-center space-y-2 pl-4 pt-2" }, { children: _jsx("div", { children: value &&
                    Object.keys(value)
                        .filter(function (key) {
                        return !["group", "street_2", "street_3", "street_4"].includes(key);
                    })
                        .map(function (item, index) { return (_jsx("span", { children: _jsxs(_Fragment, { children: [_jsx("label", __assign({ className: " font-medium text-[var(--colors-label)]" }, { children: t("".concat(group, "_").concat(item).toUpperCase()) })), _jsx(Input, { type: "text", name: item, value: value[item], size: "sm", className: "my-1", onChange: handleInputChange, autoFocus: true })] }) }, index)); }) }) })) })));
}
